import {Elements} from "@stripe/react-stripe-js";
import {stripePromise, usePaymentProvider} from "../../payment/PaymentProvider";
import {useEffect, useRef} from "react";
import {StripeAddPaymentElement} from "./StripeAddPaymentElement";
import {EuiLoadingSpinner} from "@elastic/eui";

export interface IStripeAddPaymentMethod {
    businessId: string;
    return_url: string;
    prePaymentAddedAsync?: () => Promise<void>;
    onPaymentAdded?: () => void;
    onBackClick?: () => void;
    onRemoteSignClick?: () => void;
    isDisabled?: boolean;
    isLoading?: boolean;
    confirmText?: string;
    backText?: string;
    remoteSignText?: string;
    secret?: string;
}

export const StripeAddPaymentMethod: React.FC<IStripeAddPaymentMethod> = props => {
    const {createSetupIntent, clientSecret, setSecret} = usePaymentProvider();
    const hasRun = useRef(false);

    useEffect(() => {
        if (!hasRun.current && !props.secret) {
            hasRun.current = true;
            createSetupIntent(props.businessId);
        }
    }, [createSetupIntent, props.businessId, props.secret]);

    useEffect(() => {
        if(props.secret)
        {
            setSecret(props.secret);
        }
    }, [props.secret]);

    return (
        <>
            {clientSecret && clientSecret.length > 0 ?
                <Elements stripe={stripePromise} options={{clientSecret: clientSecret}}>
                    <StripeAddPaymentElement return_url={props.return_url} onPaymentAdded={props.onPaymentAdded} onBackClick={props.onBackClick} backText={props.backText} onRemoteSignClick={props.onRemoteSignClick} remoteSignText={props.remoteSignText} confirmText={props.confirmText} prePaymentAddedAsync={props.prePaymentAddedAsync} isLoading={props.isLoading} isDisabled={props.isDisabled} />
                </Elements>
            : (
                <EuiLoadingSpinner/>
            )}
        </>
    );
}